import { Box, List, ListItem, ListItemButton, Typography } from '@mui/material';
import { Paper } from '@mui/material';
import TrainingDetailSectionHeader from './TrainingDetailSectionHeader';
import { RESIZABLE_THREE_COLUMNS } from '../../utils/resizableThreeColumns';

/**
 * 훈련 상세 왼쪽 영역 - 파일 탐색기
 */
const TrainingDetailFileExplorer = ({
  files,
  activeFileName,
  activeFileStep,
  step,
  selectedLines,
  modifiedCode,
  onFileClick,
  explorerWidth,
  minExplorerWidth,
}) => (
  <Paper
    sx={{
      width: explorerWidth,
      minWidth: minExplorerWidth,
      maxWidth: `${RESIZABLE_THREE_COLUMNS.maxLeftPercent}%`,
      flexShrink: 0,
      overflow: 'auto',
      border: '1px solid #e0e0e0',
      borderRadius: 1,
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <TrainingDetailSectionHeader title="파일 탐색기" />
    <List dense sx={{ p: 0 }}>
      {files?.map((file, index) => {
        const fileName = file?.fileName || `파일 ${index + 1}`;
        const isSelected = activeFileName === fileName;
        return (
          <ListItem key={index} disablePadding>
            <ListItemButton
              selected={isSelected}
              onClick={() => onFileClick(fileName, activeFileStep)}
              sx={{
                flexDirection: 'column',
                alignItems: 'flex-start',
                py: 1,
                px: 1.5,
                '&.Mui-selected': {
                  bgcolor: '#e3f2fd',
                  '&:hover': {
                    bgcolor: '#e3f2fd',
                  },
                },
              }}
            >
              <Box sx={{ width: '100%' }}>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: '0.875rem',
                    fontWeight: isSelected ? 600 : 400,
                    color: isSelected ? 'primary.main' : 'text.primary',
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                  }}
                >
                  {fileName}
                </Typography>
                {step === 1 ? (
                  <FileExplorerStep1Badge fileName={fileName} selectedLines={selectedLines} />
                ) : (
                  <FileExplorerStep2Badge fileName={fileName} modifiedCode={modifiedCode} />
                )}
              </Box>
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  </Paper>
);

/** 1단계: 선택된 라인 표시 */
const FileExplorerStep1Badge = ({ fileName, selectedLines }) => {
  const currentSelectedLines = selectedLines.find((item) => item.fileName === fileName)?.lineNumbers || [];
  if (currentSelectedLines.length === 0) return null;
  return (
    <Box
      sx={{
        mt: 0.5,
        px: 1,
        py: 0.25,
        bgcolor: 'primary.light',
        borderRadius: 0.5,
        display: 'inline-block',
      }}
    >
      <Typography variant="caption" sx={{ fontSize: '0.7rem', color: 'primary.contrastText', fontWeight: 500 }}>
        라인: {currentSelectedLines.join(', ')}
      </Typography>
    </Box>
  );
};

/** 2단계: 입력된 값 표시 */
const FileExplorerStep2Badge = ({ fileName, modifiedCode }) => {
  const currentFileData = modifiedCode.find((item) => item.fileName === fileName);
  const filledValues = currentFileData?.keywords || [];
  if (filledValues.length === 0) return null;
  return (
    <Typography variant="body2" color="primary" sx={{ fontWeight: 500 }}>
      입력된 값: {filledValues.join(', ')}
    </Typography>
  );
};

export default TrainingDetailFileExplorer;
